/* eslint-disable */
import React from 'react';
import i18next from 'i18next';
import { observer } from 'mobx-react';

import { ComponentRegistry } from 'core/index';
import {
  SelectWrapper,
  SelectFieldBase,
} from 'libs/forms/views/fieldTypes/select';
import { ArrayFieldStore } from 'libs/forms/fieldStores';
import { Validation } from 'libs/forms/views/validation';
import { WrappedInput, Arrow } from 'libs/forms/styles';
import { Remainder } from 'libs/forms/views/remainder';
import { Tag, TagDeleteButton } from 'legacyComponents/styled/lib';

// FIXME - review this file

export const DefaultItem = observer(({ deleteHandler, fieldStore, item }) => {
  const itemText = item[fieldStore.conf.labelKey];
  const deleteButton = (
    <TagDeleteButton
      // onClick={() => deleteHandler(item)}
    />
  );
  return (
    <Tag
      profile
      onClick={() => deleteHandler(item)}
      onMouseDown={e => {
        if (fieldStore.isFocussed) {
          e.stopPropagation();
          e.preventDefault();
        }
      }}
    >
      {itemText} {deleteButton}
    </Tag>
  );
});

@observer
export class MultiSelectField extends SelectFieldBase {
  static defaultStore = ArrayFieldStore;

  clickDeleteButton = item => {
    this.props.fieldStore.Delete(item);
    this.props.fieldStore.optionsManager.ToggleShow(true);
  };

  focusNext = () => {
    const {
      fieldStore: { value, conf },
    } = this.props;
    if (conf.maxLen && conf.maxLen === value.length) {
      const fs = this.props.fieldStore;
      const input = document.querySelector(
        `#${fs.formStore.formName}-${fs.nextFieldName}`
      );
      if (input) {
        input.focus();
      } else {
        const input = document.querySelector(
          `#${fs.formStore.formName}-${fs.fieldName}`
        );
        input.blur();
      }
    }
  };

  render() {
    const fieldStore = this.props.fieldStore;
    const { maxLen, itemName, itemComponent, appKey } = fieldStore.conf;
    let ItemComponent = ComponentRegistry.get(itemComponent);
    if (!ItemComponent) {
      ItemComponent = DefaultItem;
    }
    const selection = [];
    const selected = fieldStore.getSelectedOption;
    for (const item of selected) {
      selection.push(
        <ItemComponent
          deleteHandler={this.clickDeleteButton}
          key={item[appKey]}
          item={item}
          fieldStore={fieldStore}
        />
      );
    }
    const remainder = (
      <Remainder
        itemCount={selected.length}
        maxLen={maxLen}
        fieldStore={fieldStore}
        itemName={itemName}
        show={true}
      />
    );
    return (
      <SelectWrapper
        key={fieldStore.fieldName}
        focussed={fieldStore.isFocussed}
        onMouseDown={this.onMouseDown}
        responsive
      >
        <WrappedInput
          type='text'
          id={this.inputId}
          className='inputNoBorder'
          ref={input => (this._input = input)}
          defaultValue={''}
          placeholder={
            fieldStore.conf.placeholder &&
            i18next.t(fieldStore.conf.placeholder)
          }
          onBlur={this.onBlurSelect}
          onFocus={this.onFocusSelect}
          posting={fieldStore.formStore.posting}
          visible={false}
          // onChange={this.highlightByTyping}
          onKeyDown={e => this.onKeyDown(e)}
          autoComplete={'off'}
        />
        {selection}
        {remainder}
        <Arrow
          shiftLeft={fieldStore.showValidation}
          name={fieldStore.optionsManager?.showOptions ? 'caret_up' : 'caret_down'}
        />
        <Validation
          fieldStore={fieldStore}
          handleClick={this.focusAfterDelete}
        />
      </SelectWrapper>
    );
  }
}
